/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Apr 05 2024
 **/

import LottiePlayer from "@rsupport/lottieplayer";

import { Column } from "@/frameworks/designStuff/components";

import chatFirstLoadingData from "@/assets/lotties/chat/chat_first_loading.json";

export default function LottieLoader() {
	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: chatFirstLoadingData,
		rendererSettings: {
			preserveAspectRatio: "xMidYMid slice"
		}
	};

	return (
		<Column verticalAlign="center" horizonAlign="center" css={{ width: "100%", height: "100%" }}>
			<LottiePlayer options={defaultOptions} height={128} width={128} />
		</Column>
	);
}
